export class StatusModel {
  uId?: string;
  pinCustomer: string;
  status: string;
  statusCustomer?: string;
  statusBusiness?: string;
}
